import React, { useEffect } from 'react'
import { BaseCard } from '@verifier-user/verifier-headless-ui'
import { InfoCDR } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'

export const EnergyError = () => {
  const { expire } = useApplicationContext()
  useEffect(() => {
    expire()
  }, [])

  return (
    <>
      <h1 className={'text-4xl sm:text-5xl mb-8 leading-tight'}>Error Encountered.</h1>

      <BaseCard className='mt-0 max-w-screen-md mb-8' data-testid='error'>
        <div>
          <p data-testid={'modal-primary-content'}>
            Unfortunately there was an error and we are unable to complete your energy verification.
          </p>
          <p data-testid={'modal-error-content'}>
            If the issue persists, please let Verifier know by email at{' '}
            <a href='mailto:contact@verifier.me' id='dataCollectProgress-errorContact-link'>
              contact@verifier.me
            </a>
            , and this will be investigated further.
          </p>
        </div>
      </BaseCard>

      <InfoCDR
        accreditationLink={process.env.ACCREDITATION_LINK}
        accreditationNumber={process.env.ACCREDITATION_NUMBER}
        companyName={process.env.COMPANY}
      ></InfoCDR>
    </>
  )
}
